import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TagsService } from 'src/app/_core/_services/tags/tags.service';

export interface Tag {
  id: number;
  value: string;
  color: string;
}

@Component({
  selector: 'app-add-tag-modal',
  templateUrl: './add-tag-modal.component.html',
  styleUrls: ['./add-tag-modal.component.scss']
})
export class AddTagModalComponent implements OnInit {
  @Input() publicId!: string;
  @Input() selectedTag?: Tag; // Optional selected tag
  @Output() tagSelected: EventEmitter<Tag[]> = new EventEmitter<Tag[]>();  // Now an array of tags

  availableTags: Tag[] = [];
  selectedTags: Tag[] = [];  // Array to hold selected tags

  constructor(
    private tagsService: TagsService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.fetchAvailableTags();
  }
  
  fetchAvailableTags(): void {
    this.tagsService.getAvailableTags(this.publicId).subscribe(
      (tags: Tag[]) => {
        this.availableTags = tags;
  
        // Sync availableTags with preselected tags
        if (this.selectedTags.length) {
          this.selectedTags = this.availableTags.filter(tag =>
            this.selectedTags.some(selectedTag => selectedTag.id === tag.id)
          );
        }
      },
      (error) => {
        console.error('Error fetching available tags:', error);
      }
    );
  }
  
  

// Toggle selection of a single tag at a time
toggleTagSelection(tag: Tag): void {
  if (this.isTagSelected(tag)) {
    // If the tag is already selected, remove it
    this.selectedTags = this.selectedTags.filter(selectedTag => selectedTag.id !== tag.id);
  } else {
    // Add the tag if not already selected
    this.selectedTags.push(tag);
  }
}


// Check if a tag is selected
isTagSelected(tag: Tag): boolean {
  return this.selectedTags.some(selectedTag => selectedTag.id === tag.id);
}





// Emit the selected tags and close the modal
selectTags(): void {
  if (this.selectedTags.length) {
    // Emit the array of selected tags
    this.tagSelected.emit(this.selectedTags);
    this.activeModal.close();  // Close the modal
  } else {
    console.warn('No tags selected');
  }
}


  // Clear the selection when the modal is dismissed
  closeModal(): void {
    this.selectedTags = [];
    this.activeModal.dismiss('Cross click');
  }
}
